import {
  React,
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import moment from "moment-timezone";
import "./BookAppointment.css";
import BookAppImmi from "../../Component/BookAppointment/BookAppImmi";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import SelectTimeZone from "../../Component/Modal/SelectTimeZone";
import { Colorcontext } from "../../Component/context/ColorContext";
import BackPageBtn from "./BackPageBtn";
import toast from "react-hot-toast";
import HomeServices from "../../Services/HomeServices";
import { validTimezones } from "./TimeZone";
import { DateTime } from "luxon";
import Spinner from "../../Spinner/Spinner";

const UrgentPreferDateTime = () => {
  const colordata = useContext(Colorcontext);
  let newDate = new Date();
  const formData = JSON.parse(localStorage.getItem("formData"));
  const [TorontoTimeZone, setTorontoTimeZone] = useState("America/Toronto");
  const currentDateTimeToronto = moment.tz(TorontoTimeZone);
  const [timeBlock, setTimeBlock] = useState(false);
  // const defaultDate = currentDateTimeToronto.format("ddd, MMM D, YYYY");
  const myTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const [fetchTimeLoading, setFetchTimeLoading] = useState(false);

  // const nextDay = moment(newDate).tz(TorontoTimeZone).add(1, 'day');
  const dateTimeField = {
    // date: moment(newDate).tz(TorontoTimeZone).format(),
    date: "",
    time: "",
    value: formData,
    // value: location?.state,
  };

  const [viewBlockdate, setViewBlockdate] = useState([]);
  const [allTime, setAllTime] = useState([]);
  const [dateTime, setDateTime] = useState(dateTimeField);
  const [modalA, setModalA] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  // const [onChangeDate, setOnChangeDate] = useState(defaultDate);
  const [onChangeDate, setOnChangeDate] = useState("");
  const [searchSlotsForNextPageObject, setSearchSlotsForNextPageObject] =
    useState({});

  const location = useLocation();

  const navigate = useNavigate();

  const tileClassName = ({ date, view }) => {
    // Add a custom class to the active (selected) date
    if (
      selectedDate &&
      date.getDate() === selectedDate.getDate() &&
      date.getMonth() === selectedDate.getMonth() &&
      date.getFullYear() === selectedDate.getFullYear()
    ) {
      return "active-date";
    }
    // Add a custom class to the current date (optional)
    if (
      view === "month" &&
      date.getDate() === new Date().getDate() &&
      date.getMonth() === new Date().getMonth() &&
      date.getFullYear() === new Date().getFullYear()
    ) {
      return "current-date";
    }
    return null;
  };

  const isFirstUpdate = useRef(true);

  useEffect(() => {
    if (isFirstUpdate.current) {
      isFirstUpdate.current = false;
      return;
    }
    console.log("hello");
    GetAllDate(moment().tz(TorontoTimeZone).format("YYYY-MM-DD"));
    fetchViewBlockDate();
  }, [TorontoTimeZone, onChangeDate]);
  // }, [TorontoTimeZone]);
  // }, []);

  // original function
  // const GetAllDate = async (date) => {
  //   const date1 = new Date(onChangeDate);

  //   const year = date1.getFullYear();
  //   const month = String(date1.getMonth() + 1).padStart(2, "0");
  //   const day = String(date1.getDate()).padStart(2, "0");

  //   const formattedDate = `${year}-${month}-${day}`;

  //   let data = {
  //     booking_serviceType_id: location?.state?._id,
  //     // date: date,
  //     date: formattedDate,
  //     timezone: TorontoTimeZone,
  //   };

  //   const res = await HomeServices.availableTimeByDate(data);
  //   if (res && res?.status) {
  //     setAllTime(res?.data);
  //     setTimeBlock(res?.allTimeBlock);
  //   }
  // };

  // Amit Exprimental function
  const GetAllDate = async (date) => {
    // console.log("Amit onchange date format", onChangeDate);

    const date1 = new Date(onChangeDate);

    const year = date1.getFullYear();
    const month = String(date1.getMonth() + 1).padStart(2, "0");
    const day = String(date1.getDate()).padStart(2, "0");

    const formattedDate = `${year}-${month}-${day}`;

    let data = {
      booking_serviceType_id: location?.state?._id,
      date: formattedDate,
      timezone: TorontoTimeZone,
      // timezone: "America/Toronto",
    };

    setSearchSlotsForNextPageObject({ ...data });

    setFetchTimeLoading(true); // start loading

    const startTime = Date.now();

    try {
      const res = await HomeServices.availableTimeByDate(data);

      const elapsedTime = Date.now() - startTime;
      const remainingTime = 3000 - elapsedTime;

      if (res && res.status) {
        console.log("Amit All Time", res?.data);
        setAllTime(res?.data);
        setTimeBlock(res?.allTimeBlock);
      }

      // Ensure loading stays for at least 3 seconds
      if (remainingTime > 0) {
        setTimeout(() => {
          setFetchTimeLoading(false);
        }, remainingTime);
      } else {
        setFetchTimeLoading(false);
      }
    } catch (error) {
      console.error("⛔ API failed:", error);

      const elapsedTime = Date.now() - startTime;
      const remainingTime = 3000 - elapsedTime;

      if (remainingTime > 0) {
        setTimeout(() => {
          setFetchTimeLoading(false);
        }, remainingTime);
      } else {
        setFetchTimeLoading(false);
      }
    }
  };

  const fetchViewBlockDate = async () => {
    const res = await HomeServices.viewUrgentBlockDate();
    if (res && res?.status) {
      setViewBlockdate(res?.data);
    }
  };

  const blockDate = (date) => {
    const formatdate = moment(date).tz(TorontoTimeZone).format("YYYY-MM-DD");
    const check = viewBlockdate.find((item) => item?.block_date === formatdate);
    if (check) {
      return true;
    } else {
      return false;
    }
  };

  const handleDateChange = async (date) => {
    console.log("hello from handle date change");
    setTorontoTimeZone("America/Toronto");
    const chDate = moment(date).format("ddd, MMM D, YYYY");
    setOnChangeDate(chDate);
    console.log("Amit onchange date", moment(date).format("YYYY-MM-DD"));

    // GetAllDate(moment(date).format("YYYY-MM-DD"));

    setDateTime({
      ...dateTime,
      date: date,
      time: "",
    });

    setSelectedDate(date);
  };

  const tileDisabled = ({ date }) => {
    // console.log("GGT127", date);

    let todayDay = moment(newDate).tz(TorontoTimeZone).format("YYYYMMDD");
    let selectedDate = moment(date).format("YYYYMMDD");

    // const isToday = todayDay !== selectedDate;

    const currentDate = new Date(
      moment(newDate).tz(TorontoTimeZone).format("YYYY-MM-DD")
    );
    currentDate.setHours(0, 0, 0, 0);
    const isPastDate = todayDay > selectedDate;

    const fourteenDaysAhead = new Date();
    fourteenDaysAhead.setDate(currentDate.getDate() + 14);
    fourteenDaysAhead.setHours(0, 0, 0, 0);
    const isDateBeyondFourteenDays = date > fourteenDaysAhead;

    const isSunday = date.getDay() === 0;

    const isBlocked = blockDate(date);

    return isPastDate || isDateBeyondFourteenDays || isSunday || isBlocked;
  };

  const onSUbmit = () => {
    if (dateTime.date && dateTime.time) {
      if (typeof dateTime.time === "string") {
        const fullDateTime = new Date(dateTime.date);
        const [hours, minutes] = dateTime.time.split(":");
        fullDateTime.setHours(parseInt(hours), parseInt(minutes));

        // navigate("/urgent-joinlist", { state: dateTime });
        console.log("data", dateTime);
        console.log("data", searchSlotsForNextPageObject);
        // return;

        navigate("/urgent-joinlist", {
          state: {
            dateTime: dateTime,
            searchSlotsForNextPageObject: searchSlotsForNextPageObject,
          },
        });
      } else {
        toast.error("Invalid time format");
      }
    } else {
      toast.error("Please Select the Date and Time");
    }
  };

  const isBlocked = (item) => {
    if (timeBlock) return true;
    if (item.isBooked) return true;
    if (item.isTimeOver) return true;
    if (item.isBlockedTime) return true;
    return false;
  };
  useEffect(() => {
    colordata.setcolor(true);

    return () => {
      colordata.setcolor(false);
    };
  }, []);

  let render = false;

  function getCurrentTimeByTimezone(dateObj, timeStr) {
    const timezone = TorontoTimeZone;

    // dateObj = selectedDate, timeStr = localTime.toFormat("HH:mm")

    // Step 1: make the selected Toronto date at start of day (00:00)
    const selectedDateStart = DateTime.fromJSDate(dateObj, {
      zone: timezone,
    }).startOf("day");

    // Step 2: combine selected date with current time string
    const combinedDateTime = DateTime.fromFormat(
      `${timeStr} ${selectedDateStart.toFormat("EEE, LLL dd, yyyy")}`,
      "HH:mm EEE, LLL dd, yyyy",
      { zone: timezone }
    );

    // Step 3: check if the time belongs to the same date
    return combinedDateTime.hasSame(selectedDateStart, "day");
  }

  return (
    <>
      <section className="predateSection">
        <div className="cust_container">
          <BookAppImmi />
          <div className="row">
            <div className="col-12">
              <p className="slYuHead">Select your preferred date and time</p>
              <div className="selectClndrDiv">
                <Calendar
                  onChange={handleDateChange}
                  value={dateTime?.date}
                  tileDisabled={tileDisabled}
                  tileClassName={tileClassName}
                />
              </div>

              <div className="aviYouDiv">
                <p className="aviMonHead">Available on {onChangeDate}</p>
                <div
                  className="d-flex align-items-center"
                  style={{ flexWrap: "wrap" }}
                >
                  <p
                    className="youCnSchl blink-text"
                    style={{ fontWeight: "700" }}
                  >
                    You can schedule an appointment between 2 hour and 14 days
                    ahead of time. Time zone:{" "}
                    <i
                      style={{ fontSize: "16px", color: "red" }}
                      class="fa-solid fa-arrow-right"
                    ></i>{" "}
                    {/* <span>
                      EASTERN TIME - TORONTO (GMT-04:00)
                    </span> */}
                  </p>
                  <form>
                    <div className="form-group">
                      <select
                        style={{ paddingLeft: "5px" }}
                        className="form-control"
                        value={TorontoTimeZone}
                        onChange={(e) => setTorontoTimeZone(e.target.value)}
                      >
                        {validTimezones?.map((timezone, index) => (
                          <option key={index} value={timezone}>
                            {timezone}
                          </option>
                        ))}
                      </select>
                    </div>
                  </form>
                </div>
              </div>

              {fetchTimeLoading ? (
                <div
                // style={{
                // textAlign: "center",
                //   fontSize: "28px",
                //   color: "#ed9f18",
                //   fontWeight: "700",
                // }}
                >
                  <Spinner />
                </div>
              ) : (
                moment(onChangeDate).day() !== 0 && (
                  <div className="timeScheduleDiv">
                    <div className="sevTimeAmDiv" style={{ cursor: "pointer" }}>
                      {allTime.map((item, index) => {
                        /////////////////
                        const dateObj = new Date(onChangeDate);

                        const formattedDate = dateObj.toLocaleDateString(
                          "en-US",
                          {
                            weekday: "short",
                            month: "short",
                            day: "2-digit",
                            year: "numeric",
                          }
                        );

                        const inputDT = item?.time + " " + formattedDate;

                        const torontoTime = DateTime.fromFormat(
                          inputDT,
                          "HH:mm EEE, LLL dd, yyyy",
                          { zone: "America/Toronto" }
                        );
                        const localTime = torontoTime.setZone(TorontoTimeZone);
                        return (
                          <>
                            {!item?.isBlockedTime &&
                              !item?.isBooked &&
                              !item?.isTimeOver &&
                              getCurrentTimeByTimezone(
                                selectedDate,
                                localTime.toFormat("HH:mm")
                              ) && (
                                <>
                                  {(render = true)}
                                  <div
                                    key={index}
                                    className={`sevTimeAm ${
                                      isBlocked(item)
                                        ? "sevTimeAmSelectColor"
                                        : item.selected
                                        ? "sevTimeAmSelectColor sevTimeAmColor"
                                        : "sevTimeAmColor"
                                    }`}
                                    style={{
                                      borderColor: item.selected
                                        ? "green"
                                        : null,
                                    }}
                                    onClick={() => {
                                      setSearchSlotsForNextPageObject(
                                        (prev) => ({ ...prev, index: index })
                                      );
                                      if (!isBlocked(item)) {
                                        setAllTime((state) => {
                                          let prevIndex = state.findIndex(
                                            (it) => it.selected
                                          );
                                          if (prevIndex >= 0) {
                                            state[prevIndex].selected = false;
                                          }
                                          state[index].selected = true;

                                          return JSON.parse(
                                            JSON.stringify(state)
                                          );
                                        });
                                        setDateTime({
                                          ...dateTime,
                                          time: item._id,
                                        });
                                      }
                                    }}
                                  >
                                    {item.selected ? (
                                      <i class="fa-solid fa-check"></i>
                                    ) : null}
                                    <span
                                      style={{}}
                                      className={"sevTimeAmSelectColor"}
                                    >
                                      {" "}
                                      <span
                                        style={{
                                          margin: "5px",
                                          padding: "5px",
                                          cursor: "pointer",
                                          color:
                                            !isBlocked(item) && !item.selected
                                              ? "#fff"
                                              : null,
                                        }}
                                      >
                                        {/* {item?.time} */}
                                        {localTime.toFormat("HH:mm")}
                                        {!isBlocked(item) ? (
                                          ""
                                        ) : (
                                          <span>
                                            {" "}
                                            ( booked{" "}
                                            <i class="fa-solid fa-check"></i>)
                                          </span>
                                        )}
                                      </span>
                                    </span>{" "}
                                  </div>
                                </>
                              )}
                          </>
                        );
                      })}
                    </div>
                    {!render && dateTime?.date && (
                      <div
                        style={{
                          color: "red",
                          textAlign: "center",
                          fontSize: "32px",
                          fontWeight: "600",
                        }}
                      >
                        {/* No Slots Found */}
                        No slot found, Please select another Date.
                      </div>
                    )}
                    {!dateTime?.date && (
                      <div
                        style={{
                          // color: "#f2a81d",
                          color: "red",
                          textAlign: "center",
                          fontSize: "32px",
                          fontWeight: "600",
                        }}
                      >
                        Please Select a Date
                      </div>
                    )}
                  </div>
                )
              )}

              <div className="serMDiv">
                <p className="sevMorHead">
                  Don't see your preferred date or time?
                </p>
                <div>
                  <button
                    onClick={onSUbmit}
                    style={{ border: "none" }}
                    className="joinWaitLink m-2"
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
          <BackPageBtn backLink="/bookappointment" />
        </div>
      </section>

      {modalA && <SelectTimeZone closeTimeZoneModal={setModalA} />}
    </>
  );
};

export default UrgentPreferDateTime;
